import React, { useState } from 'react';
import { RotateCcw, Gift, CalendarClock, Cpu, Zap, CheckCircle2 } from 'lucide-react';
import CaseActionModal from './CaseActionModal';

// Right pane: the things an admin actually does to close a case out, grouped by
// what they touch — money, the booking, or the case itself.
export default function CaseResolutionBar({ data, onDone }) {
  const [action, setAction] = useState(null);

  const groups = [
    {
      title: 'FINANCIAL',
      actions: [
        {
          id: 'refund',
          label: 'ISSUE REFUND',
          hint: 'Partial or full, with a branded credit note',
          icon: RotateCcw,
        },
        {
          id: 'goodwill',
          label: 'APPLY GOODWILL CREDIT',
          hint: 'Loyalty points or a one-time code',
          icon: Gift,
        },
      ],
    },
    {
      title: 'BOOKING',
      actions: [
        {
          id: 'reschedule',
          label: 'RESCHEDULE BOOKING',
          hint: 'Move the session to a new slot',
          icon: CalendarClock,
        },
        {
          id: 'reassign_bay',
          label: 'REASSIGN BAY',
          hint: 'Swap to another available rig',
          icon: Cpu,
        },
      ],
    },
    {
      title: 'QUICK MACRO',
      actions: [
        {
          id: 'reschedule_apologise',
          label: 'RESCHEDULE & APOLOGISE',
          hint: 'New slot, credit, apology, resolved',
          icon: Zap,
          highlight: true,
        },
      ],
    },
    {
      title: 'RESOLUTION',
      actions: [
        {
          id: 'resolve',
          label: 'CLOSE / RESOLVE CASE',
          hint: 'Record how this was resolved',
          icon: CheckCircle2,
        },
      ],
    },
  ];

  return (
    <div className="space-y-4">
      {groups.map((g) => (
        <div key={g.title} className="border border-white/5 bg-[#111115]">
          <div className="px-4 py-3 border-b border-white/5">
            <p className="text-white text-[10px] font-bold tracking-widest">{g.title}</p>
          </div>
          <div className="p-3 space-y-2">
            {g.actions.map((a) => {
              const Icon = a.icon;
              return (
                <button
                  key={a.id}
                  onClick={() => setAction(a.id)}
                  className={`w-full flex items-start gap-3 border px-3 py-2.5 text-left transition-colors ${
                    a.highlight
                      ? 'border-primary/40 bg-primary/5 hover:bg-primary/10'
                      : 'border-white/10 hover:border-primary/40 hover:bg-white/[0.02]'
                  }`}
                >
                  <Icon className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                  <span className="min-w-0">
                    <span className="block text-white text-[10px] font-bold tracking-widest">
                      {a.label}
                    </span>
                    <span className="block text-white/35 text-[10px] mt-0.5">{a.hint}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {action && (
        <CaseActionModal
          action={action}
          caseData={data.case}
          orders={data.orders || []}
          rigs={data.rigs || []}
          linkedBooking={data.linkedBooking}
          onClose={() => setAction(null)}
          onDone={onDone}
        />
      )}
    </div>
  );
}